import apiClient from '../core';

export type HowToGuideStatus = 'draft' | 'published';

export interface HowToCategory {
  id: string;
  name: string;
  slug: string;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface HowToGalleryItem {
  url: string;
  cloudfrontUrl?: string;
  alt?: string;
}

export interface HowToGuide {
  id: string;
  categoryId: string;
  categoryName?: string;
  categorySlug?: string;
  title: string;
  slug: string;
  status: HowToGuideStatus;
  sortOrder: number;
  contentHtml: string;
  videoUrl: string | null;
  galleryJson: HowToGalleryItem[];
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface HowToGuidePayload {
  categoryId: string;
  title: string;
  slug?: string;
  status?: HowToGuideStatus;
  sortOrder?: number;
  contentHtml?: string;
  videoUrl?: string | null;
  galleryJson?: HowToGalleryItem[];
}

export const howtoApi = {
  async listCategories(): Promise<{ categories: HowToCategory[] }> {
    const response = await apiClient.get<{ categories: HowToCategory[] }>('/howto/categories');
    return response.data;
  },

  async createCategory(data: {
    name: string;
    slug?: string;
    sortOrder?: number;
  }): Promise<{ category: HowToCategory }> {
    const response = await apiClient.post<{ category: HowToCategory }>('/howto/categories', data);
    return response.data;
  },

  async updateCategory(
    id: string,
    data: { name?: string; slug?: string; sortOrder?: number }
  ): Promise<{ category: HowToCategory }> {
    const response = await apiClient.put<{ category: HowToCategory }>(
      `/howto/categories/${id}`,
      data
    );
    return response.data;
  },

  async listGuides(params?: {
    status?: HowToGuideStatus;
    categoryId?: string;
  }): Promise<{ guides: HowToGuide[] }> {
    const response = await apiClient.get<{ guides: HowToGuide[] }>('/howto/guides', { params });
    return response.data;
  },

  async getGuideBySlug(slug: string): Promise<{ guide: HowToGuide }> {
    const response = await apiClient.get<{ guide: HowToGuide }>(`/howto/guides/${slug}`);
    return response.data;
  },

  async createGuide(data: HowToGuidePayload): Promise<{ guide: HowToGuide }> {
    const response = await apiClient.post<{ guide: HowToGuide }>('/howto/guides', data);
    return response.data;
  },

  async updateGuide(id: string, data: HowToGuidePayload): Promise<{ guide: HowToGuide }> {
    const response = await apiClient.put<{ guide: HowToGuide }>(`/howto/guides/${id}`, data);
    return response.data;
  },

  async deleteGuide(id: string): Promise<{ message: string }> {
    const response = await apiClient.delete<{ message: string }>(`/howto/guides/${id}`);
    return response.data;
  },
};
